import React from 'react';
import { IActivityLogTabPanel } from './interfaces';
import { TabPanel } from '../../../../../components/tabs';
import { ManagedDataTable } from '../../../../../components/ManagedDataTable';
import { useGetActivityLogs } from '../../../../../reactQuery/Activities/activities';
import { IManagedDataTable } from '../../../../../components/ManagedDataTable/interfaces';
import { ActivityLog } from '../../../../../api/activitiesApi/interfaces';
import { getColumns } from '../../../../ActivitiesLog/Overview/helpers';
import { ROUTES } from '../../../../../routes/Routes';
import { useNavigate } from 'react-router';
import { DATA_TABLE_STORAGE_KEYS } from '../../../../../constants';

export const ActivityLogTabPanel: React.FC<IActivityLogTabPanel> = ({
  value,
  index,
  clientId,
}): JSX.Element => {
  const navigate = useNavigate();
  const onRowClick = (row: ActivityLog): void => {
    navigate(ROUTES.activityLog.details(row.id));
  };

  return (
    <TabPanel value={value} index={index}>
      <ManagedDataTable
        query={useGetActivityLogs as IManagedDataTable<ActivityLog>['query']}
        columns={getColumns(true)}
        onRowClick={onRowClick}
        storageKey={DATA_TABLE_STORAGE_KEYS.activityLogs}
        initialSort={{ field: 'performedAt', sort: 'desc' }}
        filter={[
          {
            field: 'client',
            operator: '=',
            value: clientId,
          },
        ]}
      />
    </TabPanel>
  );
};
